import script from "./EditTemplateModal.vue?vue&type=script&setup=true&lang=js"
export * from "./EditTemplateModal.vue?vue&type=script&setup=true&lang=js"

import "./EditTemplateModal.vue?vue&type=style&index=0&id=3306f4be&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3306f4be"]])

export default __exports__